// deps
import * as React from "react";

// internal-deps
import { PaymentProgressLoader, SwiggyInstrumentsPaymentMethodData } from "@swiggy-private/payment-ui";
import { Option } from "@swiggy-private/js-fp";
import { useEffectOnce, useMountedRef } from "@swiggy-private/core-ui";

// contexts
// import { CheckoutContext } from "@swiggy-private/checkout-core";
import { ShowPaymentContext } from "@payment-client/contexts/ShowPaymentContext";
// import { useOnPay } from "@payment-client/hooks/UseOnPay";

// constants
import { SWIGGY_PAY_PAYMENT_CODE } from "@payment-client/constants/SwiggyMoney";

// helpers
import { findSwiggyInstrumentsPaymentMethod } from "@payment-client/helpers/SwiggyInstrumentsHelper";
import { isBalanceSufficient } from "@payment-client/helpers/PaymentFallbackHelper";
import { AddMoneyConfirmProps } from "./AddMoneyConfirm";
import { CheckoutActionTypes, CheckoutContext, NEWRELIC_TABLES, recordNREvent } from "@swiggy-private/checkout-core";

export function AddSwiggyMoneyConfirm({ paymentAmount, payAction }: AddMoneyConfirmProps): React.ReactElement | null {
    const { setCheckoutState } = React.useContext(CheckoutContext);
    const { paymentResponse, loadingPayments } = React.useContext(ShowPaymentContext);
    const isMountedRef = useMountedRef();

    useEffectOnce(() => {
        setCheckoutState({ type: CheckoutActionTypes.SHOW_PAYMENTS });
        if (!isMountedRef.current || loadingPayments) {
            return;
        }
        const swiggyPayMethod: Option<SwiggyInstrumentsPaymentMethodData> = findSwiggyInstrumentsPaymentMethod(
            paymentResponse?.paymentGroup || [],
            SWIGGY_PAY_PAYMENT_CODE,
        );
        if (swiggyPayMethod.isSome()) {
            const methodData = swiggyPayMethod.unwrap();
            if (!methodData.enabled || !isBalanceSufficient(paymentAmount, methodData.eligibleBalance)) {
                recordNREvent({
                    eventType: NEWRELIC_TABLES.ADD_SWIGGY_MONEY_AUTOPAY_FAILURE,
                    isMethodEnabled: String(methodData.enabled),
                    balance: methodData.eligibleBalance,
                    paymentAmount,
                });
                return;
            }
            window.requestAnimationFrame(() => payAction(methodData));
        }
        // return (): void => {
        //     payActionRequestId != null && window.cancelAnimationFrame(payActionRequestId);
        // };
    });

    return <PaymentProgressLoader />;
}
